var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from "react";
export default function withFetcher(url, processSingleResponse = false) {
    return (WrappedComponent) => class Fetcher extends Component {
        // @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
        constructor(props) {
            super(props);
            this.state = {
                data: null,
                hasError: false,
                errorMessage: "",
                loading: false,
            };
            this._defaultErrorMessage = "We're sorry.  There was an error.";
        }
        // eslint-disable-next-line camelcase
        UNSAFE_componentWillMount() {
            this.getData(this.props.params);
        }
        // eslint-disable-next-line camelcase
        // @ts-expect-error - TS7006 - Parameter 'nextProps' implicitly has an 'any' type.
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (JSON.stringify(this.props.params) !== JSON.stringify(nextProps.params)) {
                this.getData(nextProps.params);
            }
        }
        getData(params = {}) {
            return __awaiter(this, void 0, void 0, function* () {
                let data = null;
                this.setState({ loading: true, hasError: false });
                try {
                    const response = yield fetch(url + this._toQueryString(params), {
                        credentials: "include",
                    });
                    if (!response.ok) {
                        this.setState({ hasError: true });
                    }
                    data = yield response.json();
                    if (processSingleResponse) {
                        this._processSingleResponse(data);
                    }
                    else {
                        this.setState({ data });
                        if (this.props.onData) {
                            this.props.onData(data);
                        }
                    }
                    this.setState({ loading: false });
                }
                catch (error) {
                    console.error(error);
                    this.setState({
                        hasError: true,
                        errorMessage: this._defaultErrorMessage,
                        loading: false,
                    });
                }
            });
        }
        // @ts-expect-error - TS7006 - Parameter 'data' implicitly has an 'any' type.
        _processSingleResponse(data) {
            if (data.success) {
                this.setState({ loading: false, data: data.data });
                if (this.props.onData) {
                    this.props.onData(data.data);
                }
            }
            else {
                this.setState({ hasError: true, errorMessage: data.message });
            }
        }
        _toQueryString(params) {
            let string = "?";
            if (!params || !Object.keys(params).length) {
                return "";
            }
            string += Object.keys(params)
                .map((key) => `${encodeURI(key)}=${encodeURI(params[key])}`)
                .join("&");
            return string;
        }
        render() {
            // Don't pass on page, max, or onData.
            /* eslint-disable no-unused-vars */
            const _a = this.props, { params, onData } = _a, otherProps = __rest(_a, ["params", "onData"]);
            /* eslint-enable no-unused-vars */
            // Make sure we don't send a blank error message when there is an errror.
            let errorMessage = "";
            if (this.state.errorMessage) {
                errorMessage = this.state.errorMessage;
            }
            else if (this.state.hasError) {
                errorMessage = this._defaultErrorMessage;
            }
            return (_jsx(WrappedComponent
            // @ts-expect-error - TS2322 - Type '{ fetchData: any; fetchHasError: boolean; fetchErrorMessage: string; fetchLoading: boolean; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<FetchProps<T>, {}, any>> & Readonly<FetchProps<T>>'.
            , Object.assign({ 
                // @ts-expect-error - TS2322 - Type '{ fetchData: any; fetchHasError: boolean; fetchErrorMessage: string; fetchLoading: boolean; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<FetchProps<T>, {}, any>> & Readonly<FetchProps<T>>'.
                fetchData: this.state.data, fetchHasError: this.state.hasError, fetchErrorMessage: errorMessage, fetchLoading: this.state.loading }, otherProps)));
        }
    };
}
